export default __webpack_public_path__ + "static/media/criteriaComingSoon.88de633c.svg";